

export function loadSettings() {
  const STORAGE_KEY = 'omnibox_json_converter';
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch(err) {
    console.warn('Failed to load setting', err);
    return null;
  }
}

export function loadRenamedColumns() {
  const STORAGE_KEY = 'omnibox_json_converter';
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const settings = JSON.parse(raw);
    return settings['renamed_columns'];
  } catch(err) {
    console.warn('Failed to load renamed columns', err);
    return null;
  }
}

export function loadTechniqueSettings(technique) {
  const STORAGE_KEY = 'omnibox_json_converter';
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const settings = JSON.parse(raw);
    return settings[technique];
  } catch(err) {
    console.warn('Failed to load setting', err);
    return null;
  }
}

export function saveSetting(technique, setting, selectedColumns) {
  const STORAGE_KEY = 'omnibox_json_converter';
  try {
    let json_converter = loadSettings();
    if (technique === setting) {
      if (!json_converter) {
        json_converter = {};
      }

      json_converter[technique] = { 'last_used': setting, 'templates': { [setting]: selectedColumns } };
    }
    else {
      json_converter[technique]['templates'][setting] = selectedColumns;
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(json_converter));
  } catch(err) {
    console.warn('Failed to save settings', err);
  }
}

export function saveRenamedColumns(originalName, newName) {
  const STORAGE_KEY = 'omnibox_json_converter';
  try {
    let json_converter = loadSettings();
    if (!json_converter) {
      json_converter = {};
    }
    if (!json_converter['renamed_columns']) {
      json_converter['renamed_columns'] = {};
    }

    const trimmed = (newName || '').trim();
    if (!trimmed || trimmed === originalName) {
      delete json_converter['renamed_columns'][originalName];
    } else {
      json_converter['renamed_columns'][originalName] = trimmed;
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(json_converter));
    return json_converter['renamed_columns'];
  } catch(err) {
    console.warn('Failed to save column name', err);
    return null;
  }
}

export function getDisplayName(originalName, columnNames) {
  return (columnNames && columnNames[originalName]) || originalName;
}

export function createDefaultSettings() {
  const STORAGE_KEY = 'omnibox_json_converter';
  const default_templates ={
    'CMC': ['siteId', 'siteName', 'contractNumber', 'client', 'contractor', 'pointId',
            'timeBegin', 'timeEnd', 'operator', 'version', 'omnibox', 'xLocal', 'yLocal',
            'xUtmProductionStart', 'yUtmProductionStart', 'alert', 'diameter', 'materialVolume',
            'depthMax', 'overcons', 'durationUp', 'durationPen', 'machineId', 'q0_volume', 'pumpId',
            'pumpStrokeVol', 'concreteTruckId', 'overconsCalc', 'type', 'pumpStrokes', 'GPSQualityStart',
            'inclinoXStart', 'inclinoYStart', 'durationPoint', 'ts', 'R_Depth (m)', 'R_TorquePres (bar)',
            'R_ThrustPres (bar)', 'R_IncliX', 'R_IncliY', 'R_ConcretePres (bar)', 'R_StrokeCount',
            'R_ConcretePresPump (bar)', 'C_ConcreteVolume (m3)', 'C_LoadCentralizer', 'C_RotatingSpeed_rpm (rpm)',
            'C_SpeedAbs (m/min)', 'C_SpeedUpTarget (m/min)', 'State', 'Deq (m)'
    ],
    'PVD': ['siteId', 'siteName', 'contractNumber', 'client', 'contractor', 'pointId', 
            'timeBegin', 'timeEnd', 'version', 'box', 'xLocal', 'yLocal', 'xUtmProductionStart',
            'yUtmProductionStart', 'machineId', 'autocutMode', 'depthMax', 'thrustPresMax',
            'durationPen', 'durationUp', 'durationVibroActive', 'GPSQualityStart', 'depthFirstVibroActive',
            'inclinoXStart', 'inclinoYStart', 'ts', 'R_Depth (m)', 'R_ThrustPressure (bar)',
            'R_InclinX', 'R_InclinY', 'RVibratorStatus', 'C_SpeedAbs (m/min)'
    ],
    'SC': ['siteId', 'siteName', 'contractNumber', 'client', 'contractor', 'pointId',
           'timeBegin', 'timeEnd', 'version', 'omnibox', 'xLocal', 'yLocal', 'diameter',
           'depthMax', 'materialVolume', 'durationPen', 'durationFlush', 'durationUp',
           'durationStop', 'xUtmProductionStart', 'yUtmProductionStart', 'amperageD10', 
           'ts', 'R_Depth (m)', 'R_InclinX', 'R_InclinY', 'R_VibroAmp (A)', 'C_Depth (m)',
           'State', 'Deq (m)', 'Stones used (m3)'
    ],
    'RIC': ['siteId', 'siteName', 'contractNumber', 'client', 'contractor', 'pointId',
            'timeBegin', 'timeEnd', 'version', 'box', 'xLocal', 'yLocal', 'xUtmProductionStart',
            'yUtmProductionStart', 'machineId', 'durationPoint', 'totalPenPoint', 'totaBlowPoint',
            'depthMax', 'stopReason','gpsQualityStart', 'qpsQualityStop', 'durationPen', 'ts', 
            'R_Depth (mm)', 'R_Elbow', 'R_IncliX', 'R_IncliY'
    ]
  }

  if (!localStorage[STORAGE_KEY]) {
    for (const tech of Object.keys(default_templates)) {
      saveSetting(tech, tech, default_templates[tech]);
    }
  }

  for (const tech of Object.keys(default_templates)) {
    // if (!Object.keys(localStorage[STORAGE_KEY]).includes(tech)) {
    //   saveSetting(tech, default_templates[tech]);
    // }

  }
}

{/* REWORK */}
export function updateCustomSetting(setting, detectedTechnique, selectedColumns) {
  const saved = loadTechniqueSettings(detectedTechnique)['templates'];
  if (!saved) return [];
  if (Object.keys(saved).includes(setting)) {
    // If setting is one of the defined default techniques, and a custom version exists, load the custom version.
    // Otherwise, load the desired template (which may be default or custom).
    if (detectedTechnique === setting) {
      return saved[`${setting}_custom`] ? [...saved[`${setting}_custom`]] : [...saved[setting]];
    }
    return [...saved[setting]];
  }
}


export function computeGlobalColumns(files) {
  const colOrder = [];
  const colSeen = new Set();
  let detectedTechnique = '';

  for (const entry of files) {
    let headers = [];
    let body = [];
    const entrySeen = new Set();

    if (!entry.parsed) continue;

    const json = entry.parsed;

    // if (!detectedTechnique.includes(json.technique)) detectedTechnique.push(json.technique);
    if (detectedTechnique !== json.technique) detectedTechnique = json.technique;

    try {
      if (!json.timeseries || !json.timeseries.header || !json.timeseries.header.column) {
        throw new Exception('Missing timeseries header');
      }

      for (const k of Object.keys(json)) {
        if (k === 'timeseries') continue;
        if (!colSeen.has(k)) { colSeen.add(k); colOrder.push(k); }
        if (!entrySeen.has(k)) { entrySeen.add(k); headers.push(k); }
      }

      if (!colSeen.has('ts')) { colSeen.add('ts'); colOrder.push('ts'); }
      if (!entrySeen.has('ts')) { entrySeen.add('ts'); body.push('ts'); }


      if (json.timeseries && json.timeseries.header && json.timeseries.header.column) {
        const cols = json.timeseries.header.column;
        for (const k of Object.keys(cols)) {
          if (cols[k].unit !== '' && cols[k].unit !== '°' && cols[k].unit !== "�" && cols[k].unit !== null) {
            if (!cols[k].name.includes('(')) {
              json.timeseries.header.column[k].name = `${cols[k].name} (${cols[k].unit})`;
            }
          }

          const name = cols[k].name;
          if (!colSeen.has(name)) { colSeen.add(name); colOrder.push(name); body.push(name); }
          if (!entrySeen.has(name)) { entrySeen.add(name); body.push(name); }
        }
      }
      entry.headerColumns = headers;
      entry.rawColumns = body;
    } catch (err) {
      entry.parseError = 'Incorrect JSON Structure' + (err && err.message ? err.message : 'invalid JSON');
      entry.status = 'error';
    }
  }

  if (colOrder.length === 0) {
    alert('No Columns Detected, Please select different files.');
    return;
  }

  // saveSetting('-', colOrder);

  return {
    colOrder,
    files,
    detectedTechnique
  }
}